import { useEffect } from "react";
import { oauthService } from "../../services/oauth.service";

export default function OAuthCallback() {
  useEffect(() => {
    (async () => {
      const send = (payload) => {
        try {
          if (window.opener && !window.opener.closed) {
            window.opener.postMessage(payload, window.location.origin);
          }
        } catch {}
      };

      try {
        const path = window.location.pathname;
        const provider = path.includes("/google") ? "google" : "microsoft";

        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        const state = params.get("state");
        const error = params.get("error");

        if (error) {
          send({ type: "oauth_error", provider, detail: error });
          return;
        }

        if (!code || !state) {
          send({ type: "oauth_error", provider, detail: "Missing code/state" });
          return;
        }

        const data = await oauthService.exchange({ provider, code, state });
        const { access, refresh, detail, email } = data || {};

        if (access && refresh) {
          send({ type: "oauth_success", provider, access, refresh });
          return;
        }

        if (detail) {
          const isRelink = String(detail).toLowerCase().includes("re-vinc");
          send({
            type: isRelink ? "oauth_relinked" : "oauth_linked",
            provider,
            detail,
            email: email || null,
          });
          return;
        }

        send({
          type: "oauth_error",
          provider,
          detail: "Exchange OK pero respuesta inesperada",
          backend: data,
        });
      } catch (e) {
        const path = window.location.pathname;
        const provider = path.includes("/google") ? "google" : "microsoft";

        const status = e?.response?.status;
        const respData = e?.response?.data;
        const message =
          respData?.detail || respData?.error || e?.message || String(e);

        send({
          type: "oauth_error",
          provider,
          detail: "OAuth exchange failed",
          status,
          message,
          backend: respData,
        });
      } finally {
        try {
          window.close();
        } catch {}
      }
    })();
  }, []);

  return (
    <div style={{ padding: 16, fontFamily: "sans-serif" }}>Conectando...</div>
  );
}
